import React, { useState } from 'react';
import { map } from "lodash";
import Avatar from "UI/Avatar";

import { initials } from "Data/users/UserUtilities";
import Dropdown from "UI/Dropdown";
import { DotsVerticalIcon } from "@heroicons/react/solid";
import ModalConfirm from "../../ui/ModalConfirm";

export default function TeamMemberList({members, invites, revokeInvite, removeTeamMember}) {

    if (members.length < 1 && invites.length < 1) {
        return null;
    }

    return <div className="border-t border-b border-gray-200">
        <ul className="divide-y divide-gray-200">
            {map(members, (member) => (
                <li key={member.id} className="py-4 flex items-center">
                    <Avatar circular initials={initials(member.name)} />
                    <div className="ml-3 flex flex-col flex-grow">
                        <span className="text-sm font-medium text-gray-900">{member.name}</span>
                        <span className="text-sm text-gray-500">{member.email}</span>
                    </div>
                    <TeamMemberMenu id={member.id} removeTeamMember={removeTeamMember} />
                </li>
            ))}
            {map(invites, (invite) => (
                <li key={invite.id} className="py-4 flex items-center">
                    <div className='p-2 bg-gray-500 rounded-full text-white'>
                        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"
                             xmlns="http://www.w3.org/2000/svg">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"
                                  d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                        </svg>
                    </div>
                    <div className="ml-3 flex flex-col flex-grow">
                        <span className="text-sm font-medium text-gray-900">Invite sent!</span>
                        <span className="text-sm text-gray-500">{invite.email}</span>
                    </div>
                    <TeamInviteMenu id={invite.id} revokeInvite={revokeInvite} />
                </li>
            ))}
        </ul>
    </div>;
}

const TeamMemberMenu = ({id, removeTeamMember}) => {

    const [showConfirm, setShowConfirm] = React.useState(false);

    return <>
        <Dropdown button={Dropdown.VerticalDotsButton} origin='tr'>
            <Dropdown.Item onClick={() => setShowConfirm(true)}>Remove member</Dropdown.Item>
        </Dropdown>
        <ModalConfirm danger open={showConfirm} onClose={() => setShowConfirm(false)} onConfirm={() => removeTeamMember(id)}>
            Are you sure you wish to remove this member from your team?
        </ModalConfirm>
    </>;
}

const TeamInviteMenu = ({id, revokeInvite}) => {

    const [showConfirm, setShowConfirm] = React.useState(false);

    return <>
        <Dropdown button={Dropdown.VerticalDotsButton} origin='tr'>
            <Dropdown.Item onClick={() => setShowConfirm(true)}>Revoke invite</Dropdown.Item>
        </Dropdown>

        <ModalConfirm danger open={showConfirm} onClose={() => setShowConfirm(false)} onConfirm={() => revokeInvite(id)}>
            Are you sure you wish to revoke this invite?
        </ModalConfirm>
    </>;
}
